module.exports = __webpack_public_path__ + "static/media/PM69.ef8c485a.JPG";